export default "__VITE_ASSET__DOZqNEpy__"